import { render, staticRenderFns } from "./PublishDialog.vue?vue&type=template&id=5d44a548&"
import script from "./PublishDialog.vue?vue&type=script&lang=js&"
export * from "./PublishDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports